import ky from 'ky';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000';

/**
 * Pre-configured ky instance for the Tracker API.
 * Automatically attaches JWT bearer token from localStorage.
 */
export const api = ky.create({
  prefixUrl: `${API_BASE_URL}/api`,
  timeout: 30000,
  hooks: {
    beforeRequest: [
      (request) => {
        const token = localStorage.getItem('tracker_token');
        if (token) {
          request.headers.set('Authorization', `Bearer ${token}`);
        }
      },
    ],
    afterResponse: [
      async (_request, _options, response) => {
        if (response.status === 401) {
          localStorage.removeItem('tracker_token');
          localStorage.removeItem('tracker_user');
          // Redirect to login if on a protected page
          if (window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
        }
      },
    ],
  },
});

/**
 * Update the stored auth token.
 */
export function setAuthToken(token: string | null): void {
  if (token) {
    localStorage.setItem('tracker_token', token);
  } else {
    localStorage.removeItem('tracker_token');
    localStorage.removeItem('tracker_user');
  }
}

/**
 * Get the current auth user from localStorage.
 */
export function getStoredUser(): { userId: string; userName: string } | null {
  const raw = localStorage.getItem('tracker_user');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
